import { render, staticRenderFns } from "./SpartanIntro.vue?vue&type=template&id=bc53d254&scoped=true&"
import script from "./SpartanIntro.vue?vue&type=script&lang=js&"
export * from "./SpartanIntro.vue?vue&type=script&lang=js&"
import style0 from "./SpartanIntro.vue?vue&type=style&index=0&id=bc53d254&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc53d254",
  null
  
)

export default component.exports